import { API_URLS } from "../../constants/apiUrls";
import { commonFetch } from "../commonFetch";

export const insertStudent = async (formData) => {
  return commonFetch("Student/InsertStudent", {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

export const getAllStudents = async (schoolID, academicYearID) => {
  return commonFetch(`Student/GetAllStudentsList?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`, {
    method: "GET",
    requiresAuth: true,
  });
};

export const getAllStudentsList = async ( schoolID, academicYearID, classID = "", sectionID = "", streamID = "", subStreamID = "", pageNumber, pageSize ,DisplayType) => {
  let url = `Student/GetAllStudentsList?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`;
  
  if (classID) url += `&ClassID=${classID}`;
  if (sectionID) url += `&SectionID=${sectionID}`;
  if (streamID) url += `&StreamID=${streamID}`;
  if (subStreamID) url += `&SubStreamID=${subStreamID}`;
  if (pageNumber) url += `&PageNumber=${pageNumber}`;
  if (pageSize) url += `&PageSize=${pageSize}`;
  if (DisplayType) url += `&DisplayType=${DisplayType}`;

  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};



export const getAllStudentsTable = async (payload) => {
  return commonFetch(`Student/GetAllStudents`, {
    method: "Post",
    body: payload,
    requiresAuth: true,
  });
};

export const getAllEmployeeStudents = async (payload) => {
  return commonFetch(
    `Student/GetAllEmployeeStudents`,
    {
      method: "POST",
      body: payload,
      requiresAuth: true,
    }
  );
};




export const getStudentDetailsById = async (id, academicYearID) => {
  return commonFetch(`Student/GetStudentDetailsById?StudentID=${id}&AcademicYearID=${academicYearID}`, {
    method: "GET",
      requiresAuth: true,
    });
};

export const StudentVisitByParent = async (formParentVisit) => {
   return commonFetch(`${API_URLS.PARENT_VISIT_STUDENT_DASH}`, {
      method: "POST",
      body: formParentVisit,
      requiresAuth: true,
    });
};

export const ParentAddKidID = async (payload) => {
   return commonFetch(`${API_URLS.PARENT_ADD_KID_ID}`, {
      method: "POST",
       body: payload,
      requiresAuth: true,
    });
};

export const VarifyOTPParentAddKidID = async (payload) => {
   return commonFetch(`${API_URLS.VARIFY_PARENT_ADD_KID_ID}`, {
      method: "POST",
       body: payload,
      requiresAuth: true,
    });
};